var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-record-recharge"},[_c('tableBox',{attrs:{"tableData":_vm.tableData,"tableHead":_vm.tableHead,"total":_vm.total,"size":_vm.pageSize},on:{"pageHandler":_vm.pageOperate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }